import { Text } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Button, Flex, Form, FormInstance, Input } from 'antd'

import { Trash } from 'iconsax-react'

import { useStyles } from './styles'

type Props = {
  disabled?: boolean
  form: FormInstance
}

export const CustomFieldsOptionsItem = ({ disabled, form }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  const existingOptions = form.getFieldValue('options')

  return (
    <Form.List name="options">
      {(fields, { add, remove }) => (
        <>
          <Text size={16} weight={500}>
            {t('nomenclature.options')}
          </Text>
          {fields.map(({ key, name, ...restField }) => {
            const label = form.getFieldValue(['options', name, 'label'])

            const isExisting = existingOptions?.some(
              (option: { label: string }) => option.label === label
            )

            return (
              <Flex className={styles.options} key={key} gap={8}>
                <Form.Item
                  {...restField}
                  name={[name, 'label']}
                  rules={[
                    {
                      required: true,
                      message: t('account_settings.this_field_is_required')
                    }
                  ]}
                  className="w-full"
                >
                  <Input
                    disabled={disabled && isExisting}
                    className="w-full"
                    placeholder={t('nomenclature.value')}
                  />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'value']}
                  rules={[
                    {
                      required: true,
                      message: t('account_settings.this_field_is_required')
                    }
                  ]}
                  className="w-full"
                  label={null}
                >
                  <Input
                    className="w-full"
                    placeholder={t('nomenclature.label')}
                  />
                </Form.Item>
                <Button
                  className={styles.deleteButton}
                  danger
                  icon={<Trash size={16} />}
                  onClick={() => remove(name)}
                />
              </Flex>
            )
          })}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} block>
              {t('nomenclature.add_option')}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  )
}
